import React from 'react';
import PropTypes from 'prop-types';
import CustomButton, {
  defaultButtonStyle,
} from 'components/common/CustomButton';

const ResultPageButton = ({
  showEditResultButton = true,
  showEditEventButton = true,
  isAdd = false,
  buttonDisabled,
  handleEditResult,
  handleEditEvent,
}) => {
  return (
    <div style={{ minHeight: '35px', display: 'flex' }}>
      {showEditEventButton && (
        <CustomButton
          variant="primary"
          disabled={buttonDisabled}
          style={{
            ...defaultButtonStyle, 
            backgroundColor: '#3b82f6',
            marginBottom: 0, 
            height: 'unset', 
            padding: '4px 20px',
            marginRight: 10,
          }}
          onClick={handleEditEvent}
        >
          Edit Event
        </CustomButton>
      )}
      {showEditResultButton && (
        <CustomButton
          disabled={buttonDisabled}
          style={{
            ...defaultButtonStyle,
            marginBottom: 0,
            height: 'unset',
            padding: '4px 20px',
          }}
          onClick={handleEditResult}
        >
          {isAdd ? '+ Add Results' : 'Edit Results'}
        </CustomButton>
      )}
    </div>
  );
};

ResultPageButton.propTypes = {
  showEditResultButton: PropTypes.bool,
  showEditEventButton: PropTypes.bool,
  isAdd: PropTypes.bool,
  buttonDisabled: PropTypes.bool,
  handleEditResult: PropTypes.func,
  handleEditEvent: PropTypes.func,
};

export default ResultPageButton;
